"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AuthenticationContext_1 = tslib_1.__importDefault(require("./AuthenticationContext"));
/* eslint-disable react/jsx-props-no-spreading */
function PrivateRoute(routeProps) {
    var children = routeProps.children, Component = routeProps.component, routePropsWithoutChildrenAndComponent = tslib_1.__rest(routeProps, ["children", "component"]);
    var _a = react_1.useContext(AuthenticationContext_1["default"]), authorize = _a.authorize, authenticated = _a.authenticated, authenticating = _a.authenticating, callbackPath = _a.callbackPath;
    var location = react_router_dom_1.useLocation();
    var match = react_router_dom_1.useRouteMatch(routePropsWithoutChildrenAndComponent);
    react_1.useEffect(function () {
        if (!authenticated && !authenticating && match && location.pathname !== callbackPath) {
            authorize(location);
        }
    }, [authorize, match, location, authenticated, authenticating, callbackPath]);
    return (react_1["default"].createElement(react_router_dom_1.Route, tslib_1.__assign({}, routePropsWithoutChildrenAndComponent, { render: function (props) {
            if (!authenticated)
                return null;
            if (Component)
                return react_1["default"].createElement(Component, tslib_1.__assign({}, props));
            if (routeProps.render)
                return routeProps.render(props);
            return children;
        } })));
}
PrivateRoute.propTypes = react_router_dom_1.Route.propTypes;
exports["default"] = PrivateRoute;
//# sourceMappingURL=PrivateRoute.js.map